export const Routes = {
    openHomepage: () => '/',
    openArticle: (id: string) => `/article/${id}`,
    openCategory: (slug: string = '') => `/${slug}`, // NOTE: slug is null sometimes :D
    openTag: (slug: string = '') => `/tag/${slug}`,
    openAuthor: (id: string = '') => `/author/${id}`,
    openSearch: (text: string = '', page?: string) => `/search?q=${text}${page ? `&page=${page}` : ''}`,
    openVideos: (page?: string) => (page ? `/videa?page=${page}` : '/videa'),
};
